import SlideX from "../../atoms/slide-x"

const Process = ({img, title, desc}) => {
    return (
        <div className="process">
            <SlideX>
                <img src={img} alt="Process" />
            </SlideX>
            <h5>{title}</h5>
            <p>{desc}</p>
        </div>
    )
}

export default Process;